import { Box, Flex } from "@chakra-ui/react";
import { ArrowCircleUpRight, ArrowUpRight } from "@phosphor-icons/react";

/**
 * A padded border to go around e.g. a DashboardNumber
 */
export default function DashboardCard({ children, minWidth, maxWidth, onClick, bg = "transparent", px = 4 }) {
  return (
    <Flex
      direction="column"
      px={px}
      border="1px"
      borderColor="gray.200"
      borderRadius="md"
      boxShadow="xs"
      gap={2}
      pb={8}
      pt={onClick ? 2 : 9}
      // pt={8}
      minWidth={minWidth}
      maxWidth={maxWidth}
      cursor={onClick ? "pointer" : "default"}
      onClick={onClick}
      bg={bg}
      height="100%"
    >

      {onClick && (<Box alignSelf="end" top={2} right={2} p={0.5} borderRadius="full" bg="gray.100">
          <ArrowUpRight size={16} weight="bold" color="#4B8407" />
        </Box>
      )}
      {children}
    </Flex>
  );
}
